export default __webpack_public_path__ + "static/media/sound.3d232bd0.mp3";